import { Links, Meta } from 'lib.shared/src/types';
import { OrganizerLanding } from 'lib.store/src/type-organizer/models';
export enum ModerationFiltersKeys {
  events = 'events',
  sponsors = 'sponsors',
  statuses = 'statuses',
  partners = 'partners',
}
export interface GetOrganizerLandingResponse {
  data: OrganizerLanding[];
  links: Links;
  meta: Meta;
}
export interface GetOrganizerLandingsParams {
  search?: string;
  page: number;
  filters: {
    statuses?: string[];
    partners?: string[];
    events?: string[];
    tags?: string[];
    search?: string;
  };
}
export interface PatchOrganizerLandingStatusByIdResponse {
  data: OrganizerLanding;
}
export interface GetOrganizerLandingFilterByIdResponse {
  data: {
    id: number;
    slug: string;
  }[];
  links: Links;
  meta: Meta;
}

export interface GetOrganizerLandingByIdResponse {
  data: OrganizerLanding;
}

export interface ReusableSetupLanding {
  id: number;
  event: { id: string; name: string };
  status: { id: string; name: string; translate?: string };
  date: { created_at: string | null };
}
